import {
  CACHE_INIT_START,
  CACHE_INIT_SUCCESS,
  CACHE_INIT_ERROR
} from '../constants/ActionTypes';

const initialState = {
  isInitializing: false,
  isInitialized: false,
  error: null
};

export default function cacheReducer(state = initialState, action) {
  switch (action.type) {
    case CACHE_INIT_START:
      return {
        ...state,
        isInitializing: true,
        isInitialized: false,
        error: null
      };

    case CACHE_INIT_SUCCESS:
      return {
        ...state,
        isInitializing: false,
        isInitialized: true,
        error: null
      };

    case CACHE_INIT_ERROR:
      return {
        ...state,
        isInitializing: false,
        isInitialized: false,
        error: action.payload
      };

    default:
      return state;
  }
}
